(function(window, document) {
  if (window.__auxitoBundleDiscountBarLoaded) return;
  window.__auxitoBundleDiscountBarLoaded = true;

  var bar = document.querySelector("[data-auxito-bundle-discount-bar]");
  if (!bar) return;

  var selectors = {
    coupon: ".auxito-bundle-discount-bar__coupon",
    ringCapEnd: ".auxito-bundle-discount-bar__ring-cap--end",
    couponPercent: "[data-auxito-bundle-coupon-percent]",
    headline: "[data-auxito-bundle-headline]",
    note: "[data-auxito-bundle-note]",
    avatars: "[data-auxito-bundle-avatars]",
    totalLabel: "[data-auxito-bundle-total-label]",
    total: "[data-auxito-bundle-total]",
    original: "[data-auxito-bundle-original]",
    save: "[data-auxito-bundle-save]",
    itemsPreview: "[data-auxito-bundle-items-preview]",
    previewButton: "[data-auxito-bundle-preview-button]",
    viewItems: "[data-auxito-bundle-view-items]",
    popover: "[data-auxito-bundle-popover]",
    popoverCount: "[data-auxito-bundle-popover-count]",
    popoverList: "[data-auxito-bundle-popover-list]",
    popoverViewCart: "[data-auxito-bundle-popover-view-cart]",
    buyNow: "[data-auxito-bundle-buy-now]"
  };

  var els = {};
  Object.keys(selectors).forEach(function(key) {
    els[key] = bar.querySelector(selectors[key]);
  });

  var tiers = parseTiers(bar.getAttribute("data-tiers") || "");
  var moneyFormat = bar.getAttribute("data-money-format") || "${{amount}}";
  var cartJsonUrl = bar.getAttribute("data-cart-json-url") || "/cart.js";
  var checkoutUrl = bar.getAttribute("data-checkout-url") || "/checkout";
  var isProductPage = bar.getAttribute("data-product-page") === "true";
  var fixedBarDisabled = isProductPage;

  if (isProductPage) {
    bar.hidden = true;
    bar.classList.remove("is-visible");
    document.body.classList.remove("auxito-bundle-discount-bar-visible");
  }

  var latestCart = null;
  var visible = false;
  var fetchTimer = null;
  var offsetFrame = null;
  var messageSyncTimer = null;
  var refreshBackoffUntil = 0;
  var drawerOpenInFlight = false;
  var lastDrawerOpenAt = 0;
  var popoverCloseTimer = null;
  var popoverOpenFrame = null;
  var lastPopoverTrigger = null;
  var progressFrame = null;
  var progressHasAnimated = false;
  var progressTargetAngle = "";

  if (!tiers.length) return;

  bar.classList.toggle("is-product-page", isProductPage);

  function parseTiers(value) {
    return String(value || "")
      .split(",")
      .map(function(part) {
        var pieces = part.split(":");
        var quantity = parseInt(pieces[0], 10);
        var percent = parseFloat(pieces[1]);
        var code = pieces.slice(2).join(":").trim();
        if (!quantity || !percent) return null;
        return {
          quantity: quantity,
          percent: percent,
          code: code
        };
      })
      .filter(Boolean)
      .sort(function(left, right) {
        return left.quantity - right.quantity;
      });
  }

  function getCachedCart() {
    var drawerCart = window.Auxito && window.Auxito.CartDrawer && window.Auxito.CartDrawer.latestCart;
    if (drawerCart && drawerCart.items) return drawerCart;
    if (window._auxitoLatestCart && window._auxitoLatestCart.items) return window._auxitoLatestCart;
    return latestCart && latestCart.items ? latestCart : null;
  }

  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function getItemCount(cart) {
    return parseInt(cart && cart.item_count, 10) || 0;
  }

  function getCurrentTier(count) {
    var current = null;
    for (var i = 0; i < tiers.length; i++) {
      if (count >= tiers[i].quantity) current = tiers[i];
    }
    return current;
  }

  function getNextTier(count) {
    for (var i = 0; i < tiers.length; i++) {
      if (count < tiers[i].quantity) return tiers[i];
    }
    return null;
  }

  function getOriginalSubtotal(cart) {
    var value = parseInt(cart && cart.original_total_price, 10);
    var items = cart && cart.items || [];
    var total = 0;
    var i;
    if (Number.isFinite(value) && value > 0) return value;
    value = parseInt(cart && cart.items_subtotal_price, 10);
    if (Number.isFinite(value) && value > 0) return value;
    for (i = 0; i < items.length; i++) {
      total += parseInt(items[i].original_line_price != null ? items[i].original_line_price : items[i].line_price, 10) || 0;
    }
    if (total > 0) return total;
    return parseInt(cart && cart.total_price, 10) || 0;
  }

  function getActualDiscount(cart, originalSubtotal) {
    var total = parseInt(cart && cart.total_price, 10) || 0;
    var discount = parseInt(cart && cart.total_discount, 10);
    var applications = cart && cart.cart_level_discount_applications || [];
    var allocated = 0;
    var i;
    if (Number.isFinite(discount) && discount > 0) return discount;
    for (i = 0; i < applications.length; i++) {
      allocated += parseInt(applications[i] && applications[i].total_allocated_amount, 10) || 0;
    }
    if (allocated > 0) return allocated;
    return Math.max(0, (originalSubtotal || 0) - total);
  }

  function cleanImageUrl(url) {
    url = String(url || "").trim();
    if (!url || url === "null" || url === "undefined" || url === "[object Object]") return "";
    if (url.indexOf("//") === 0) return window.location.protocol + url;
    if (url.charAt(0) === "/") return window.location.origin + url;
    return url;
  }

  function normalizeImageUrl(value) {
    var nested;
    if (!value) return "";
    if (typeof value === "string") return cleanImageUrl(value);
    if (typeof value !== "object") return "";
    nested = value.url ||
      value.src ||
      value.originalSrc ||
      value.transformedSrc ||
      value.preview_image ||
      value.image ||
      value.featured_image;
    if (nested === value) return "";
    return normalizeImageUrl(nested);
  }

  function getImageUrl(item) {
    if (!item) return "";
    return normalizeImageUrl(item.image) ||
      normalizeImageUrl(item.featured_image) ||
      normalizeImageUrl(item.variant_image) ||
      normalizeImageUrl(item.product_image);
  }

  function getItemTitle(item) {
    return item && (item.product_title || item.title || "Cart item") || "Cart item";
  }

  function getItemVariantText(item) {
    var options = item && item.options_with_values;
    var parts = [];
    var title = item && item.variant_title;
    if (title && title !== "Default Title") return title;
    if (Array.isArray(options)) {
      options.forEach(function(option) {
        var name = option && option.name;
        var value = option && option.value;
        if (!value || value === "Default Title") return;
        parts.push((name ? name + ": " : "") + value);
      });
    }
    return parts.join(" / ");
  }

  function getItemLinePrice(item) {
    return parseInt(item && (item.final_line_price != null ? item.final_line_price : item.line_price), 10) || 0;
  }

  function setHtml(el, html) {
    if (el) el.innerHTML = html;
  }

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  function pluralizeItems(count) {
    return count === 1 ? "item" : "items";
  }

  function buildAddMoreText(count, nextTier) {
    var remaining = Math.max(0, nextTier.quantity - count);
    return "Add " + remaining + " more to unlock " + stripPercent(nextTier.percent) + "% OFF \u2192";
  }

  function buildEmptyText(firstTier) {
    return {
      headline: "You've selected 0 items",
      note: "Add " + firstTier.quantity + " " + pluralizeItems(firstTier.quantity) + " to unlock " + stripPercent(firstTier.percent) + "% OFF \u2192"
    };
  }

  function getTierStatusLabel(actualDiscount, currentTier) {
    if (!currentTier) return "unlocked";
    return actualDiscount > 0 ? "applied" : "unlocked";
  }

  function getTierStatusNote(actualDiscount, currentTier) {
    if (currentTier) {
      return actualDiscount > 0 ? "Discount applied in cart." : "Discount applies automatically at checkout.";
    }
    return "Discount applies automatically at checkout.";
  }

  function buildCartMessage(count, currentTier, nextTier, actualDiscount) {
    var headline = "You've selected " + count + " " + pluralizeItems(count);
    var note;
    if (currentTier && nextTier) {
      headline += " \u00b7 " + stripPercent(currentTier.percent) + "% OFF " + getTierStatusLabel(actualDiscount, currentTier);
      note = buildAddMoreText(count, nextTier);
    } else if (currentTier) {
      headline += " \u00b7 " + stripPercent(currentTier.percent) + "% OFF " + getTierStatusLabel(actualDiscount, currentTier);
      note = getTierStatusNote(actualDiscount, currentTier);
    } else if (nextTier) {
      note = buildAddMoreText(count, nextTier);
    } else {
      note = "Max discount unlocked.";
    }
    return {
      headline: headline,
      note: note || "",
      percent: stripPercent((currentTier || nextTier || tiers[0]).percent)
    };
  }

  function buildSelectedHeadline(count, currentTier, actualDiscount) {
    var headline = "You've selected " +
      "<span class=\"auxito-bundle-discount-bar__accent\">" + count + "</span> " +
      pluralizeItems(count);
    if (currentTier) {
      headline += " <span class=\"auxito-bundle-discount-bar__accent\">" +
        stripPercent(currentTier.percent) + "% OFF " + getTierStatusLabel(actualDiscount, currentTier) + "</span>";
    }
    return headline;
  }

  function stripPercent(value) {
    return parseFloat(value) % 1 === 0 ? String(parseInt(value, 10)) : String(value);
  }

  function getProgressAngle(count) {
    var minAngle = 112;
    var maxTier = tiers[tiers.length - 1];
    var maxQuantity = maxTier && maxTier.quantity || 1;
    var ratio;
    if (count >= maxQuantity) return 360;
    if (count < 1) return minAngle;
    ratio = Math.max(0, Math.min(count, maxQuantity)) / maxQuantity;
    return Math.round(minAngle + ((360 - minAngle) * ratio));
  }

  function setProgress(count, currentTier, nextTier) {
    var targetAngle = getProgressAngle(count) + "deg";
    var hadPendingFrame;

    if (els.coupon) {
      hadPendingFrame = !!progressFrame;
      if (progressFrame) {
        window.cancelAnimationFrame(progressFrame);
        progressFrame = null;
      }
      if (!progressHasAnimated) {
        setProgressAngle("0deg");
        progressFrame = window.requestAnimationFrame(function() {
          progressFrame = null;
          setProgressAngle(targetAngle);
        });
        progressHasAnimated = true;
      } else if (targetAngle !== progressTargetAngle || hadPendingFrame) {
        setProgressAngle(targetAngle);
      }
      progressTargetAngle = targetAngle;
      els.coupon.classList.toggle("is-pending", !currentTier);
      els.coupon.classList.toggle("is-active", !!currentTier && !!nextTier);
      els.coupon.classList.toggle("is-complete", !!currentTier && !nextTier);
    }
    bar.classList.toggle("is-unlocked", !!currentTier && !nextTier);
    bar.classList.toggle("is-next", !!nextTier);
  }

  function setProgressAngle(angle) {
    if (els.coupon) {
      els.coupon.style.setProperty("--auxito-bundle-progress-angle", angle);
    }
    if (els.ringCapEnd) {
      els.ringCapEnd.style.setProperty("--auxito-bundle-progress-angle", angle);
    }
  }

  function getVisibleAvatarCount() {
    if (!els.avatars) return 0;
    return els.avatars.querySelectorAll("img:not([hidden])").length;
  }

  function updateAvatarPreviewState() {
    var visibleImages = getVisibleAvatarCount();
    var more = els.avatars && els.avatars.querySelector(".auxito-bundle-discount-bar__avatar-more");
    var hasPreview = visibleImages > 0;
    if (more) more.hidden = !hasPreview;
    if (els.avatars) els.avatars.hidden = !hasPreview;
    if (els.previewButton) {
      els.previewButton.hidden = !hasPreview;
      els.previewButton.disabled = !hasPreview;
    }
    if (els.itemsPreview) {
      els.itemsPreview.hidden = !hasPreview;
    }
    bar.classList.toggle("has-items-preview", hasPreview);
  }

  function handleAvatarImageError(event) {
    var img = event && event.currentTarget;
    if (!img) return;
    img.hidden = true;
    img.removeAttribute("src");
    updateAvatarPreviewState();
    scheduleLayoutOffset();
  }

  function renderAvatars(cart) {
    var items = cart && cart.items || [];
    var max = 3;
    var rendered = 0;
    var image;
    var img;
    var more;
    if (!els.avatars) return;
    els.avatars.innerHTML = "";
    for (var i = 0; i < items.length && rendered < max; i++) {
      image = getImageUrl(items[i]);
      if (!image) continue;
      img = document.createElement("img");
      img.src = image;
      img.alt = "";
      img.decoding = "async";
      img.loading = "lazy";
      img.width = 50;
      img.height = 50;
      img.title = getItemTitle(items[i]);
      img.addEventListener("error", handleAvatarImageError, { once: true });
      els.avatars.appendChild(img);
      rendered++;
    }
    if (rendered > 0 && items.length > rendered) {
      more = document.createElement("span");
      more.className = "auxito-bundle-discount-bar__avatar-more";
      more.textContent = "+" + (items.length - rendered);
      els.avatars.appendChild(more);
    }
    updateAvatarPreviewState();
  }

  function handlePopoverImageError(event) {
    var img = event && event.currentTarget;
    var placeholder;
    if (!img || !img.parentNode) return;
    placeholder = document.createElement("span");
    placeholder.className = "auxito-bundle-discount-bar__popover-thumb-placeholder";
    placeholder.setAttribute("aria-hidden", "true");
    img.parentNode.replaceChild(placeholder, img);
  }

  function createPopoverThumb(item, title) {
    var image = getImageUrl(item);
    var thumb;
    if (!image) {
      thumb = document.createElement("span");
      thumb.className = "auxito-bundle-discount-bar__popover-thumb-placeholder";
      thumb.setAttribute("aria-hidden", "true");
      return thumb;
    }
    thumb = document.createElement("img");
    thumb.className = "auxito-bundle-discount-bar__popover-thumb";
    thumb.src = image;
    thumb.alt = title;
    thumb.decoding = "async";
    thumb.loading = "lazy";
    thumb.width = 54;
    thumb.height = 54;
    thumb.addEventListener("error", handlePopoverImageError, { once: true });
    return thumb;
  }

  function renderPopover(cart) {
    var items = cart && cart.items || [];
    var count = getItemCount(cart);
    var empty;
    if (!els.popoverList) return;
    setText(els.popoverCount, count + " " + pluralizeItems(count));
    els.popoverList.innerHTML = "";
    if (!count || !items.length) {
      empty = document.createElement("p");
      empty.className = "auxito-bundle-discount-bar__popover-empty";
      empty.textContent = "No selected items yet.";
      els.popoverList.appendChild(empty);
      closeItemsPopover();
      return;
    }
    items.forEach(function(item) {
      var title = getItemTitle(item);
      var variantText = getItemVariantText(item);
      var row = document.createElement("div");
      var copy = document.createElement("div");
      var titleEl = document.createElement("span");
      var quantityEl = document.createElement("span");
      var totalEl = document.createElement("span");
      row.className = "auxito-bundle-discount-bar__popover-item";
      copy.className = "auxito-bundle-discount-bar__popover-item-copy";
      titleEl.className = "auxito-bundle-discount-bar__popover-item-title";
      titleEl.textContent = title;
      copy.appendChild(titleEl);
      if (variantText) {
        var variantEl = document.createElement("span");
        variantEl.className = "auxito-bundle-discount-bar__popover-item-variant";
        variantEl.textContent = variantText;
        copy.appendChild(variantEl);
      }
      quantityEl.className = "auxito-bundle-discount-bar__popover-item-qty";
      quantityEl.textContent = "× " + (parseInt(item && item.quantity, 10) || 0);
      copy.appendChild(quantityEl);
      totalEl.className = "auxito-bundle-discount-bar__popover-item-total";
      totalEl.textContent = formatMoney(getItemLinePrice(item));
      row.appendChild(createPopoverThumb(item, title));
      row.appendChild(copy);
      row.appendChild(totalEl);
      els.popoverList.appendChild(row);
    });
  }

  function renderCartMessages(count, currentTier, nextTier, actualDiscount, shownDiscount, isEstimatedDiscount) {
    var messages = document.querySelectorAll("[data-auxito-bundle-cart-message-root], [data-auxito-bundle-cart-message]");
    var data;
    if (!messages.length) return;
    data = buildCartMessage(count, currentTier, nextTier, actualDiscount);
    Array.prototype.forEach.call(messages, function(message) {
      var percent = message.querySelector("[data-auxito-bundle-cart-percent]");
      var headline = message.querySelector("[data-auxito-bundle-cart-headline]");
      var note = message.querySelector("[data-auxito-bundle-cart-note]");
      var save = message.querySelector("[data-auxito-bundle-cart-save]");
      if (percent) percent.textContent = data.percent;
      if (headline) headline.textContent = data.headline;
      if (note) note.textContent = data.note;
      if (save) {
        save.textContent = shownDiscount > 0 ? (isEstimatedDiscount ? "Est. savings at checkout " : "Save ") + formatMoney(shownDiscount) : "";
        save.hidden = shownDiscount <= 0;
      }
      message.setAttribute("data-auxito-bundle-cart-message", "");
      message.setAttribute("data-cart-count", String(count));
      message.classList.toggle("is-empty", count < 1);
      message.classList.toggle("has-progress", !!currentTier);
      message.classList.toggle("is-unlocked", !!currentTier);
      message.classList.toggle("is-estimated", isEstimatedDiscount);
      message.hidden = false;
      message.removeAttribute("hidden");
    });
  }

  function renderCart(cart) {
    var count = getItemCount(cart);
    var currentTier = getCurrentTier(count);
    var nextTier = getNextTier(count);
    var displayTier = currentTier || nextTier || tiers[0];
    var firstTier = tiers[0];
    var originalSubtotal = getOriginalSubtotal(cart);
    var actualDiscount = getActualDiscount(cart, originalSubtotal);
    var estimatedDiscount = currentTier ? Math.round(originalSubtotal * currentTier.percent / 100) : 0;
    var isEstimatedDiscount = !!currentTier && actualDiscount <= 0 && estimatedDiscount > 0;
    var shownDiscount = actualDiscount > 0 ? actualDiscount : estimatedDiscount;
    var shownTotal = actualDiscount > 0 ? Math.max(0, originalSubtotal - actualDiscount) : originalSubtotal;
    var headline;

    latestCart = cart;
    renderPopover(cart);

    if (count < 1) {
      var emptyText = buildEmptyText(firstTier);
      renderCartMessages(count, currentTier, nextTier, actualDiscount, shownDiscount, isEstimatedDiscount);
      if (fixedBarDisabled) {
        hideBar();
        return;
      }
      setHtml(els.headline, emptyText.headline);
      setText(els.note, emptyText.note);
      setText(els.couponPercent, stripPercent(firstTier.percent));
      setText(els.totalLabel, "");
      setText(els.total, "");
      if (els.original) {
        els.original.hidden = true;
        els.original.textContent = "";
      }
      if (els.save) {
        els.save.hidden = true;
        els.save.textContent = "";
      }
      if (els.buyNow) {
        els.buyNow.textContent = "Buy Now";
        els.buyNow.href = checkoutUrl;
      }
      bar.classList.add("is-empty");
      bar.classList.remove("is-estimated");
      setProgress(0, null, firstTier);
      renderAvatars(cart);
      updateAvatarPreviewState();
      showBar();
      return;
    }

    if (fixedBarDisabled) {
      renderCartMessages(count, currentTier, nextTier, actualDiscount, shownDiscount, isEstimatedDiscount);
      hideBar();
      return;
    }

    bar.classList.remove("is-empty");

    if (!currentTier) {
      headline = buildSelectedHeadline(count, null);
      setText(els.note, nextTier ? buildAddMoreText(count, nextTier) : "");
    } else if (nextTier) {
      headline = buildSelectedHeadline(count, currentTier, actualDiscount);
      setText(els.note, buildAddMoreText(count, nextTier));
    } else {
      headline = buildSelectedHeadline(count, currentTier, actualDiscount);
      setText(els.note, getTierStatusNote(actualDiscount, currentTier));
    }

    renderCartMessages(count, currentTier, nextTier, actualDiscount, shownDiscount, isEstimatedDiscount);
    setHtml(els.headline, headline);
    setText(els.couponPercent, stripPercent(displayTier.percent));
    setText(els.totalLabel, actualDiscount > 0 ? "Total:" : "Subtotal:");
    setText(els.total, formatMoney(shownTotal));
    if (els.original) {
      els.original.hidden = actualDiscount <= 0;
      els.original.textContent = actualDiscount > 0 ? formatMoney(originalSubtotal) : "";
    }
    if (els.save) {
      els.save.hidden = shownDiscount <= 0;
      els.save.textContent = shownDiscount > 0 ? (isEstimatedDiscount ? "Est. savings at checkout " : "Save ") + formatMoney(shownDiscount) : "";
    }
    if (els.buyNow) {
      els.buyNow.textContent = "Buy Now";
      els.buyNow.href = checkoutUrl;
    }

    bar.classList.toggle("is-estimated", isEstimatedDiscount);
    setProgress(count, currentTier, nextTier);
    renderAvatars(cart);
    updateAvatarPreviewState();
    showBar();
  }

  function showBar() {
    if (!visible) {
      visible = true;
      bar.hidden = false;
      window.requestAnimationFrame(function() {
        bar.classList.add("is-visible");
        document.body.classList.add("auxito-bundle-discount-bar-visible");
        updateLayoutOffset();
      });
      return;
    }
    updateLayoutOffset();
  }

  function hideBar() {
    visible = false;
    closeItemsPopover();
    bar.classList.remove("is-visible");
    bar.classList.remove("is-empty");
    bar.classList.remove("is-estimated");
    document.body.classList.remove("auxito-bundle-discount-bar-visible");
    updateLayoutOffset();
    window.setTimeout(function() {
      if (!visible) bar.hidden = true;
    }, 240);
  }

  function getStickyProductBarHeight() {
    var sticky = document.querySelector(".sticky-bottom-bar.is-visible");
    if (!sticky) return 0;
    return Math.ceil(sticky.getBoundingClientRect().height || sticky.offsetHeight || 0);
  }

  function getShopifyPreviewBarHeight() {
    var previewBar = document.getElementById("PBarNextFrameWrapper");
    var rect;
    var style;
    if (!previewBar) return 0;
    style = window.getComputedStyle(previewBar);
    if (style.display === "none" || style.visibility === "hidden" || style.position !== "fixed") return 0;
    rect = previewBar.getBoundingClientRect();
    if (rect.bottom < window.innerHeight - 4) return 0;
    return Math.ceil(rect.height || previewBar.offsetHeight || 0);
  }

  function updateLayoutOffset() {
    var previewHeight = getShopifyPreviewBarHeight();
    var barHeight = visible ? Math.ceil(bar.getBoundingClientRect().height || bar.offsetHeight || 0) : 0;
    var stickyHeight = visible ? getStickyProductBarHeight() : 0;
    var pageOffset = barHeight + stickyHeight + previewHeight;
    document.documentElement.style.setProperty("--auxito-bundle-preview-bar-offset", previewHeight + "px");
    document.documentElement.style.setProperty("--auxito-bundle-discount-bar-height", barHeight + "px");
    document.documentElement.style.setProperty("--auxito-bundle-discount-page-offset", pageOffset + "px");
  }

  function scheduleLayoutOffset() {
    if (offsetFrame) return;
    offsetFrame = window.requestAnimationFrame(function() {
      offsetFrame = null;
      updateLayoutOffset();
    });
  }

  function scheduleCartMessageSync(delay) {
    if (!latestCart) return;
    if (messageSyncTimer) window.clearTimeout(messageSyncTimer);
    messageSyncTimer = window.setTimeout(function() {
      messageSyncTimer = null;
      if (latestCart) renderCart(cloneCart(latestCart));
    }, delay == null ? 140 : delay);
  }

  function syncCartMessagesAfter(delay) {
    window.setTimeout(function() {
      if (latestCart) renderCart(cloneCart(latestCart));
    }, delay);
  }

  function cloneCart(cart) {
    try {
      return JSON.parse(JSON.stringify(cart));
    } catch (error) {
      return cart;
    }
  }

  function syncExternalCart(cart) {
    if (!cart || !cart.items) return;
    latestCart = cart;
    window._auxitoLatestCart = cart;
    if (window.Auxito && window.Auxito.CartDrawer) {
      window.Auxito.CartDrawer.latestCart = cart;
    }
  }

  function refreshCart(force) {
    var cached = getCachedCart();
    var now = Date.now();
    if (cached && !force) {
      renderCart(cached);
    }
    if (now < refreshBackoffUntil) {
      if (cached) renderCart(cached);
      return Promise.resolve(cached);
    }
    return fetch(cartJsonUrl, {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function(response) {
        var contentType = response.headers.get("content-type") || "";
        if (response.status === 429) {
          refreshBackoffUntil = Date.now() + 10000;
        }
        if (!response.ok) throw new Error("Cart fetch failed: " + response.status);
        if (contentType.indexOf("application/json") === -1 && contentType.indexOf("text/javascript") === -1) {
          throw new Error("Cart fetch returned non-JSON content.");
        }
        return response.json();
      })
      .then(function(cart) {
        syncExternalCart(cart);
        renderCart(cart);
        return cart;
      })
      .catch(function() {
        if (cached) renderCart(cached);
      });
  }

  function clearScheduledRefresh() {
    if (!fetchTimer) return;
    window.clearTimeout(fetchTimer);
    fetchTimer = null;
  }

  function scheduleRefresh(delay) {
    if (fetchTimer) window.clearTimeout(fetchTimer);
    fetchTimer = window.setTimeout(function() {
      fetchTimer = null;
      refreshCart(true);
    }, delay == null ? 550 : delay);
  }

  function asPromise(value) {
    if (value && typeof value.then === "function") return value;
    return Promise.resolve(value);
  }

  function fetchCartForDrawer(controller) {
    var cached = latestCart || getCachedCart();
    if (cached && cached.items) {
      return Promise.resolve(cached);
    }
    if (controller && typeof controller.fetchCart === "function") {
      return controller.fetchCart(true).then(function(cart) {
        if (cart && cart.items) {
          syncExternalCart(cart);
          return cart;
        }
        return cached;
      }).catch(function() {
        return cached;
      });
    }
    return refreshCart(true).then(function(cart) {
      return cart || latestCart || getCachedCart() || cached;
    }).catch(function() {
      return cached;
    });
  }

  function tryOpenCartDrawer(cart, trigger) {
    var drawer = window.Auxito && window.Auxito.CartDrawer;
    var drawerController = drawer && (drawer.controller || window.AuxitoCartDrawerController);
    if (drawer && typeof drawer.openCart === "function") {
      try {
        return {
          handled: true,
          result: drawer.openCart(cart, trigger)
        };
      } catch (error) {}
    }
    if (drawerController && typeof drawerController.openWithCart === "function" && cart && cart.items) {
      try {
        return {
          handled: true,
          result: drawerController.openWithCart(cart, trigger)
        };
      } catch (error) {}
    }
    if (drawerController && typeof drawerController.open === "function") {
      try {
        return {
          handled: true,
          result: drawerController.open(trigger)
        };
      } catch (error) {}
    }
    return null;
  }

  function openCartWithServiceOrDrawer(controller, cart, trigger) {
    var cartTrigger;
    var drawerAttempt;

    if (controller && typeof controller.openCart === "function" && cart && cart.items) {
      try {
        return asPromise(controller.openCart(cart, trigger));
      } catch (error) {}
    }

    drawerAttempt = tryOpenCartDrawer(cart, trigger);
    if (drawerAttempt && drawerAttempt.handled) {
      return asPromise(drawerAttempt.result);
    }

    cartTrigger = document.querySelector(".js-site-header-cart--button, [data-site-header-cart], [data-header-cart-trigger]");
    if (cartTrigger && typeof cartTrigger.click === "function") {
      cartTrigger.click();
      return Promise.resolve();
    }

    if (els.note) {
      setText(els.note, "Use the cart icon to view selected items.");
    }

    return Promise.resolve();
  }

  function openCartView(event) {
    var controller = window.Auxito && window.Auxito.CartService;
    var trigger = event && event.currentTarget || els.viewItems || null;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    closeItemsPopover();
    if (document.querySelector(".auxito-cart-drawer.visible")) {
      updateCartDrawerActiveState();
      syncCartMessagesAfter(120);
      return;
    }
    if (drawerOpenInFlight && Date.now() - lastDrawerOpenAt < 1200) return;
    drawerOpenInFlight = true;
    lastDrawerOpenAt = Date.now();
    bar.classList.add("is-cart-drawer-active");
    fetchCartForDrawer(controller).then(function(cart) {
      var drawerAttempt = tryOpenCartDrawer(cart, trigger);
      if (drawerAttempt && drawerAttempt.handled) {
        return asPromise(drawerAttempt.result).catch(function() {
          return openCartWithServiceOrDrawer(controller, cart, trigger);
        });
      }
      return openCartWithServiceOrDrawer(controller, cart, trigger);
    }).then(function() {
      updateCartDrawerActiveState();
      syncCartMessagesAfter(120);
      syncCartMessagesAfter(700);
      drawerOpenInFlight = false;
    }).catch(function() {
      drawerOpenInFlight = false;
      if (els.note) {
        setText(els.note, "Use the cart icon to view selected items.");
      }
    });
    syncCartMessagesAfter(180);
    syncCartMessagesAfter(650);
    syncCartMessagesAfter(1200);
  }

  function goToCheckout(event) {
    if (!els.buyNow || els.buyNow.getAttribute("href") !== checkoutUrl) return;
    event.preventDefault();
    els.buyNow.classList.add("is-loading");
    window.location.href = checkoutUrl;
  }

  function canUseHoverOpen() {
    return !window.matchMedia || window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }

  function shouldOpenCartDirectly() {
    return !canUseHoverOpen();
  }

  function setPopoverExpanded(isOpen) {
    if (els.viewItems) els.viewItems.setAttribute("aria-expanded", isOpen ? "true" : "false");
    if (els.previewButton) els.previewButton.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  function cancelItemsPopoverClose() {
    if (!popoverCloseTimer) return;
    window.clearTimeout(popoverCloseTimer);
    popoverCloseTimer = null;
  }

  function showItemsPopover(cart) {
    if (!els.popover || !cart || getItemCount(cart) < 1) return;
    cancelItemsPopoverClose();
    renderPopover(cart);
    positionItemsPopover(lastPopoverTrigger);
    els.popover.hidden = false;
    if (popoverOpenFrame) window.cancelAnimationFrame(popoverOpenFrame);
    popoverOpenFrame = window.requestAnimationFrame(function() {
      popoverOpenFrame = null;
      bar.classList.add("is-popover-open");
      setPopoverExpanded(true);
    });
  }

  function openItemsPopover(event) {
    var cart = latestCart || getCachedCart();
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      lastPopoverTrigger = event.currentTarget || lastPopoverTrigger;
    }
    if (cart && getItemCount(cart) > 0) {
      showItemsPopover(cart);
      return;
    }
    refreshCart(true).then(function(nextCart) {
      showItemsPopover(nextCart || latestCart || getCachedCart());
    });
  }

  function closeItemsPopover() {
    cancelItemsPopoverClose();
    if (popoverOpenFrame) {
      window.cancelAnimationFrame(popoverOpenFrame);
      popoverOpenFrame = null;
    }
    bar.classList.remove("is-popover-open");
    setPopoverExpanded(false);
    window.setTimeout(function() {
      if (els.popover && !bar.classList.contains("is-popover-open")) {
        els.popover.hidden = true;
      }
    }, 180);
  }

  function positionItemsPopover(trigger) {
    var source = trigger || els.viewItems || els.previewButton;
    var barRect;
    var sourceRect;
    var popoverWidth;
    var sourceCenter;
    var left;
    var arrowLeft;

    if (!els.popover || !source || !source.getBoundingClientRect) return;

    barRect = bar.getBoundingClientRect();
    sourceRect = source.getBoundingClientRect();
    popoverWidth = Math.min(430, Math.max(280, window.innerWidth - 24));
    sourceCenter = sourceRect.left + (sourceRect.width / 2) - barRect.left;
    left = sourceCenter - 84;
    left = Math.max(12, Math.min(left, Math.max(12, barRect.width - popoverWidth - 12)));
    arrowLeft = Math.max(24, Math.min(sourceCenter - left - 9, popoverWidth - 42));

    els.popover.style.setProperty("--auxito-bundle-popover-left", Math.round(left) + "px");
    els.popover.style.setProperty("--auxito-bundle-popover-arrow-left", Math.round(arrowLeft) + "px");
  }

  function scheduleItemsPopoverClose() {
    cancelItemsPopoverClose();
    popoverCloseTimer = window.setTimeout(function() {
      popoverCloseTimer = null;
      closeItemsPopover();
    }, 420);
  }

  function isInsideItemsPopoverRegion(target) {
    return !!(target && target.nodeType === 1 && (target === bar || bar.contains(target)));
  }

  function bindItemsPopoverTrigger(element, clickHandler) {
    if (!element) return;
    element.addEventListener("click", function(event) {
      if (shouldOpenCartDirectly()) {
        openCartView(event);
        return;
      }
      (clickHandler || openItemsPopover)(event);
    });
    element.addEventListener("focus", function(event) {
      if (canUseHoverOpen()) openItemsPopover(event);
    });
    element.addEventListener("pointerenter", function(event) {
      if (canUseHoverOpen()) openItemsPopover(event);
    });
    element.addEventListener("pointerleave", function(event) {
      if (isInsideItemsPopoverRegion(event.relatedTarget)) return;
      scheduleItemsPopoverClose();
    });
  }

  function bindItemsPopoverEvents() {
    bar.addEventListener("pointerenter", cancelItemsPopoverClose);
    bar.addEventListener("pointerleave", function(event) {
      if (isInsideItemsPopoverRegion(event.relatedTarget)) return;
      scheduleItemsPopoverClose();
    });
    if (els.popover) {
      els.popover.addEventListener("pointerenter", cancelItemsPopoverClose);
      els.popover.addEventListener("pointerleave", scheduleItemsPopoverClose);
      els.popover.addEventListener("click", function(event) {
        event.stopPropagation();
      });
    }
    document.addEventListener("click", function(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest("[data-auxito-bundle-popover], [data-auxito-bundle-view-items], [data-auxito-bundle-preview-button]")) return;
      closeItemsPopover();
    });
    document.addEventListener("keydown", function(event) {
      if (event.key === "Escape") closeItemsPopover();
    });
  }

  function bindCartEvents() {
    document.addEventListener("cart:refresh", function(event) {
      var cart = event && event.detail && event.detail.cart;
      if (cart && cart.items && cart !== latestCart) renderCart(cart);
      if (cart && cart.items) clearScheduledRefresh();
    });
    document.addEventListener("cart:opened", function() {
      updateCartDrawerActiveState();
      syncCartMessagesAfter(160);
      syncCartMessagesAfter(900);
      scheduleRefresh(250);
    });
    document.addEventListener("click", function(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest("[data-product-atc], [data-quick-buy], [data-atc-remove-item], .atc-recommended-add-btn, #stickyAtcBtn")) {
        scheduleRefresh(900);
      }
    }, true);
    document.addEventListener("submit", function(event) {
      var form = event.target;
      var action = form && form.getAttribute && form.getAttribute("action");
      if (action && /\/cart\/add/.test(action)) {
        scheduleRefresh(900);
      }
    }, true);
    document.addEventListener("change", function(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest("[data-cartitem-quantity-fly], [data-cartitem-quantity], [data-quantity-input]")) {
        scheduleRefresh(700);
      }
    }, true);
    window.addEventListener("resize", function() {
      scheduleLayoutOffset();
      scheduleCartMessageSync(120);
    });
    window.addEventListener("orientationchange", function() {
      window.setTimeout(scheduleLayoutOffset, 350);
    });
    window.addEventListener("pageshow", function(event) {
      if (event && event.persisted) {
        scheduleRefresh(600);
      }
    });
    if (window.jQuery) {
      window.jQuery(document).on("cartcount:update.auxito-bundle-discount-bar", function(event, payload) {
        if (payload && payload.response && payload.response.items) {
          clearScheduledRefresh();
          renderCart(payload.response);
        }
      });
      window.jQuery(".site-header-wrapper").first().on("cartcount:update.auxito-bundle-discount-bar", function(event, payload) {
        if (payload && payload.response && payload.response.items) {
          clearScheduledRefresh();
          renderCart(payload.response);
        }
      });
    }
  }

  function updateCartDrawerActiveState() {
    var isActive = !!document.querySelector(".auxito-cart-drawer.visible");
    bar.classList.toggle("is-cart-drawer-active", isActive);
  }

  function scheduleInitialCartRefresh() {
    var run = function() {
      refreshCart(false);
    };

    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 1500 });
      return;
    }

    if (document.readyState === "complete") {
      window.setTimeout(run, 350);
      return;
    }

    window.addEventListener("load", function() {
      window.setTimeout(run, 350);
    }, { once: true });
  }

  bindItemsPopoverTrigger(els.viewItems);
  bindItemsPopoverTrigger(els.previewButton);
  bindItemsPopoverEvents();
  if (els.popoverViewCart) {
    els.popoverViewCart.addEventListener("click", openCartView);
  }
  if (els.buyNow) {
    els.buyNow.addEventListener("click", goToCheckout);
  }

  bindCartEvents();
  scheduleInitialCartRefresh();
})(window, document);
